module.exports = __webpack_public_path__ + "img/forBarnaThumbnail.496db6d5.png";